import { memo } from 'react';

import classes from './offices-block.module.scss';
import { IOfficesBlockProps } from './OfficesBlock.type';

function OfficesBlock({
  officesBlockShow = true,
  officesBlockTitle = 'Офисы',
  officesFirstTown,
  officesSecondTown,
  officesFirstTownText,
  officesSecondTownText,
}: IOfficesBlockProps) {
  return officesBlockShow && (officesFirstTown || officesSecondTown) ? (
    <div
      className={classes.container}
    >
      <div className={classes.header}>
        {officesBlockTitle}
      </div>
      <div className={classes.offices}>
        {officesFirstTown && (
          <div className={classes.officeCard}>
            <div className={classes.heading}>
              <div className={classes.headingCity}>{officesFirstTown}</div>
            </div>
            <div className={classes.officeText}>{officesFirstTownText}</div>
          </div>
        )}

        {officesSecondTown && (
          <div className={classes.officeCard}>
            <div className={classes.heading}>
              <div className={classes.headingCity}>{officesSecondTown}</div>
            </div>
            <div className={classes.officeText}>{officesSecondTownText}</div>
          </div>
        )}
      </div>
    </div>
  ) : null;
}

export default memo(OfficesBlock);
